export default "__VITE_ASSET__DrQ0Ok6E__"